import { checkPermission } from '@/router/guards.ts'

const RoleModule = () => import('./RoleModule.vue')
const RoleIndex = () => import('./views/RoleIndex.vue')

export const roleRoute = {
  path: '/roles',
  name: 'role',
  component: RoleModule,
  meta: {
    title: 'Roles',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'roles-index',
      component: RoleIndex,
      meta: {
        permission: 'role.view',
      },
      beforeEnter: checkPermission('role.view'),
    },
  ],
}
